var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.76874 5.46428L11.4253 5.17451M2.70787 5.78435L1.82534 8.76228C1.6121 9.48192 1.50544 9.84174 1.59843 10.0519C1.67912 10.2343 1.84203 10.3671 2.03688 10.4097C2.26139 10.4586 2.59253 10.282 3.2548 9.92874L10.4208 6.10651C10.9979 5.79875 11.2864 5.64483 11.3733 5.44591C11.449 5.27283 11.4423 5.07485 11.3552 4.90729C11.2551 4.71463 10.9569 4.58049 10.3604 4.31219L2.95359 0.980475C2.26908 0.67257 1.92682 0.518617 1.70609 0.582558C1.51455 0.638045 1.36098 0.781611 1.29275 0.968969C1.21411 1.18489 1.34467 1.53676 1.60587 2.2404L2.68659 5.15228C2.72964 5.26824 2.75118 5.3262 2.76092 5.38587C2.76961 5.43891 2.77142 5.4928 2.76632 5.54621C2.76061 5.60649 2.74302 5.66576 2.70787 5.78435Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.c1a15366eb6dd5db8a4048d5ef8bfd1c.svg";
export { ForwardRef as ReactComponent };